angular.module('unergie.main')
.directive('jsondetails', ($sce) => ({
    restrict: 'E',
    templateUrl: '/directives/jsondetails/jsondetails.html',
    scope: {
        details: '=',
        parse: '=',
        placement: '=',
        trigger: '=',
        hover: '=',
    },
    link($scope) {
        const parseObject = function (padding, object) {
            let toReturn = ''
            if (angular.isArray(object) || angular.isObject(object)) {
                _.forEach(object, (value, key) => {
                    toReturn += `<div>${'&nbsp;&nbsp;|  '.repeat(padding)}<b>${key}</b>: `
                    if (angular.isArray(value)) {
                        toReturn += `<br>${parseArray(padding, value)}`
                    } else if (angular.isObject(value)) {
                        toReturn += parseObject(padding + 1, value)
                    } else {
                        toReturn += `${value}</div>`
                    }
                })
            } else {
                toReturn += `<div>${'&nbsp;&nbsp;|  '.repeat(padding)}${object}`
            }
            return toReturn
        }

        function parseArray(padding, object) {
            return `&nbsp;┌<br>${_.map(object, parseObject.bind(null, padding + 1)).join('&nbsp;└<br>&nbsp;┌')}&nbsp;└`
        }

        if ($scope.parse) {
            $scope.details = JSON.parse($scope.details)
        }

        $scope.result = $sce.trustAsHtml(angular.isArray($scope.details) ? parseArray(0, $scope.details) : parseObject(0, $scope.details))
    },
}))
